module.exports = __webpack_public_path__ + "img/burger.9b1fcc77.svg";